"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _dsIcons = require("@olxbr/ds-icons");
var _propTypes = require("prop-types");
var _style = require("./style");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var messageStatus = {
  sent: 'sent',
  read: 'read',
  error: 'error',
  sending: 'sending'
};
var icons = {
  read: function read() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.Check2Small, {
      size: 16,
      color: 'var(--color-feedback-info-100)'
    });
  },
  error: function error() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.XCircle, {
      size: 16,
      color: 'var(--color-neutral-120)'
    });
  },
  sent: function sent() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.Check2Small, {
      size: 16,
      color: 'var(--color-neutral-100)'
    });
  },
  sending: function sending() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.Clock, {
      size: 16,
      color: 'var(--color-neutral-120)'
    });
  }
};
var Default = function Default() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
};
var StatusIcon = exports.StatusIcon = function StatusIcon(_ref) {
  var _icons$messageStatus$;
  var status = _ref.status;
  var Icon = (_icons$messageStatus$ = icons[messageStatus[status]]) !== null && _icons$messageStatus$ !== void 0 ? _icons$messageStatus$ : Default;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.IconArea, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {})
  });
};
StatusIcon.propTypes = {
  status: _propTypes.string
};